import { useEffect, useState } from 'react'

import { ChildProps } from '@/common/util/props'

import Button from '@/components/view/atoms/button/Button'
import SortButton from '@/components/view/atoms/button/SortButton'
import Text from '@/components/view/atoms/text/Text'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import ButtonList from '@/components/view/layouts/button/ButtonList'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'
import FormRow from '@/components/view/layouts/form/FormRow'

interface Props extends ChildProps {
  onComplete(startAt: string | undefined, endAt: string | undefined): void
  quantity?: number
  defaultStartValue?: string | null
  defaultEndValue?: string | null
}

const DisclosureSortDateBetweenButton = ({
  children,
  onComplete,
  quantity,
  defaultStartValue,
  defaultEndValue
}: Props) => {
  const [startDate, setStartDate] = useState<string>(defaultStartValue ?? '')
  const [endDate, setEndDate] = useState<string>(defaultEndValue ?? '')
  const [showing, setShowing] = useState<boolean>(false)

  useEffect(() => {
    setStartDate(defaultStartValue ?? '')
    setEndDate(defaultEndValue ?? '')
  }, [defaultStartValue, defaultEndValue])

  return (
    <DisclosureWrapper
      disclosureNode={
        <FormRow direction='vertical' gap={8} align='end'>
          <FormRow gap={8} align='center'>
            <TextField
              type='date'
              size={TextBoxSize.FULL}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <Text>-</Text>
            <TextField
              type='date'
              size={TextBoxSize.FULL}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </FormRow>
          <ButtonList justify='start'>
            <Button color={'secondary'} onClick={() => setShowing(false)}>
              キャンセル
            </Button>
            <Button
              type='button'
              onClick={() => {
                onComplete(startDate, endDate)
                setShowing(false)
              }}
            >
              適用
            </Button>
          </ButtonList>
        </FormRow>
      }
      onClickOutSide={() => setShowing(false)}
      off={!showing}
    >
      <SortButton
        onClick={() => {
          setStartDate(defaultStartValue ?? '')
          setEndDate(defaultEndValue ?? '')
          setShowing(true)
        }}
        quantity={quantity && quantity > 0 ? quantity : undefined}
        onClickDelete={
          quantity && quantity > 0
            ? () => {
                setStartDate('')
                setEndDate('')
                onComplete(undefined, undefined)
              }
            : undefined
        }
        selected={quantity && quantity > 0 ? true : false}
      >
        {children}
      </SortButton>
    </DisclosureWrapper>
  )
}

export default DisclosureSortDateBetweenButton
